import Vue from 'vue';
import { isEmpty } from 'lodash';
import api from '../api';

export default {
  namespaced: true,
  state: {
    staffPreferences: {
      cards: {
      },
    },
    menu: [],
    leftColumnCards: [],
    rightColumnCards: [],
  },
  actions: {
    async FETCH_DASHBOARD_DATA({ dispatch, rootGetters, commit }) {
      const [response] = await Promise.all([
        api.fetchDashboardSiteConfig(rootGetters.site.id),
        dispatch('activity/FETCH_ACTIVITY_FEED', null, { root: true }),
      ]);
      commit('SET_DASHBOARD', response);
    },
    async SAVE_SHORTCUTS({ commit, dispatch, state }, { cardId, shortcuts }) {
      // Optimistic update
      commit('SET_CARD_CONFIG', { cardId, config: { shortcuts } });
      dispatch('UPDATE_STAFF_PREFERENCES', state.staffPreferences, { root: true });
    },
    async CREATE_SHORTCUT({ dispatch, getters, state }, { cardId, shortcut }) {
      const cardStaffPreferences = getters.getCardStaffPreferences(cardId);
      const shortcuts = [...(cardStaffPreferences.shortcuts || [])];
      shortcuts.push(shortcut);
      return dispatch('SAVE_SHORTCUTS', { cardId, shortcuts });
    },
    async SAVE_PUBLICATIONS_SEARCH({ commit, dispatch, state }, { cardId, searchUuid }) {
      // Optimistic update
      commit('SET_CARD_CONFIG', { cardId, config: { searchUuid } });
      return dispatch('UPDATE_STAFF_PREFERENCES', state.staffPreferences, { root: true });
    },
    async SAVE_STORED_SEARCHES_CURRENT_ENTITY({ commit, dispatch, state }, { cardId, savedSearchesEntity }) {
      commit('SET_CARD_CONFIG', { cardId, config: { savedSearchesEntity } });
      return dispatch('UPDATE_STAFF_PREFERENCES', state.staffPreferences, { root: true });
    },
  },
  getters: {
    getCardStaffPreferences: state => cardId => (state.staffPreferences.cards ? state.staffPreferences.cards[cardId] : null),
    showDashboardRevertHomepage: (state, getters, rootState) => !rootState.profile.onboarding.dashboardRevertHomepageShown,
  },
  mutations: {
    SET_DASHBOARD: (state, {
      menu, leftColumnCards = [], rightColumnCards = [], staffPreferences = {},
    }) => {
      state.menu = menu;
      state.leftColumnCards = leftColumnCards;
      state.rightColumnCards = rightColumnCards;
      state.staffPreferences = isEmpty(staffPreferences) ? {} : staffPreferences;
    },
    SET_CARD_CONFIG(state, { cardId, config }) {
      if (!state.staffPreferences.cards) {
        Vue.set(state.staffPreferences, 'cards', {});
      }
      Vue.set(state.staffPreferences.cards, cardId, config);
    },
  },
};
